import { useEffect, useState } from "react";
import "./App.css";
import { auth } from "./firebase";
import ReservationPage from "./pages/ReservationPageAdm";
import LoginPageAdm from "./pages/LoginPageAdm";
import LoginPageClient from "./pages/LoginClient";
import PriceListAdm from "./pages/PriceListAdm";
import RegulaminAdm from "./pages/RegulaminAdm";
import KontaktAdm from "./pages/KontaktAdm";
import UsersAdm from "./pages/UsersAdm";
import Regulamin from "./pages/Regulamin";
import Kontakt from "./pages/Kontakt";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import HomePageClient from "./pages/HomePageClient";

function App() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [roleLoading, setRoleLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) {
      setUserRole(null);
      setRoleLoading(false);
      return;
    }

    const loadRole = async () => {
      setRoleLoading(true);
      try {
        const docRef = doc(db, "users", user.uid);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          setUserRole(data.role || "user");
        } else {
          await setDoc(
            docRef,
            {
              email: user.email || "",
              role: "user",
              createdAt: serverTimestamp()
            },
            { merge: true }
          );
          setUserRole("user");
        }
      } catch (err) {
        setUserRole("user");
      } finally {
        setRoleLoading(false);
      }
    };

    loadRole();
  }, [user]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(err.message || "Logowanie nie powiodlo sie.");
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  if (loading || roleLoading) {
    return (
      <div className="App">
        <div className="Card">
          <p className="Muted">Ladowanie...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<LoginPageClient />} /> */}
          <Route
            path="/"
            element={
              user ? (
                <Navigate to="/home_page_client" replace />
              ) : (
                <LoginPageClient
                  email={email}
                  password={password}
                  error={error}
                  onEmailChange={(event) => setEmail(event.target.value)}
                  onPasswordChange={(event) => setPassword(event.target.value)}
                  onSubmit={handleLogin}
                />
              )
            }
          />
          <Route
            path="/home_page_client"
            element={
              user ? (
                <HomePageClient
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          <Route
            path="/regulamin-client"
            element={
              user ? (
                <Regulamin
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          <Route
            path="/kontakt-client"
            element={
              user ? (
                <Kontakt
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          
          <Route
            path="/login_adm"
            element={
              user ? (
                userRole === "admin" || userRole === "moderator" ? (
                  <Navigate to="/adm" replace />
                ) : (
                  <Navigate to="/home_page_client" replace />
                )
              ) : (
                <LoginPageAdm
                  email={email}
                  password={password}
                  error={error}
                  onEmailChange={(event) => setEmail(event.target.value)}
                  onPasswordChange={(event) => setPassword(event.target.value)}
                  onSubmit={handleLogin}
                />
              )
            }
          />
          <Route
            path="/adm"
            element={
              user && (userRole === "admin" || userRole === "moderator") ? (
                <ReservationPage
                  userEmail={user.email}
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to={user ? "/home_page_client" : "/login_adm"} replace />
              )
            }
          />
          <Route
            path="/price-list"
            element={
              user && userRole === "admin" ? (
                <PriceListAdm
                  userEmail={user.email}
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to={user ? "/home_page_client" : "/login_adm"} replace />
              )
            }
          />
          <Route
            path="/regulamin"
            element={
              user && userRole === "admin" ? (
                <RegulaminAdm
                  userEmail={user.email}
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to={user ? "/home_page_client" : "/login_adm"} replace />
              )
            }
          />
          <Route
            path="/kontakt"
            element={
              user && userRole === "admin" ? (
                <KontaktAdm
                  userEmail={user.email}
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to={user ? "/home_page_client" : "/login_adm"} replace />
              )
            }
          />
          <Route
            path="/users"
            element={
              user && userRole === "admin" ? (
                <UsersAdm
                  userEmail={user.email}
                  onLogout={handleLogout}
                  userRole={userRole}
                />
              ) : (
                <Navigate to={user ? "/home_page_client" : "/login_adm"} replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
